import { Button, Card, CardContent, Chip, Divider, Stack, Typography } from "@mui/material";
import { formatarCPFCNPJ } from "../../../../../../../helpers/masks";
import { CardProps } from "..";
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import { useContext, useState } from "react";
import { usePermission } from "../../../../../../../components/PermissionGuard";
import DialogEditarSituacaoFinanceira from "./DialogEditarSituacaoFinanceira";
import { useDetalhePublico } from "../../../../../../../contexts/DialogsContext/DetalhePublicoContext";
import { AuthContext } from "../../../../../../../contexts/AuthContext";

export default function CardResumo({
    data,
}: PropsCardResumo) {
    const { tokenDecoded } = useContext(AuthContext)
    const hasPermission = usePermission("cadastros.dados-financeiro-do-publico")
    const tipo_publico = tokenDecoded?.perfis_vinculados.find(
        (perfil) => (perfil.tipo_publico || "").includes(data.tipo_publico)
      );
    const publicoVerificado = hasPermission && tipo_publico?.tipo_publico.some(tp => tp.toLowerCase().trim() === data.tipo_publico.toLowerCase().trim())
    const { openModal } = useDetalhePublico()
    const [openSituacaoFinanceira, setOpenSituacaoFinanceira] = useState(false);

    const podeEditarSituacaoFinanceira = usePermission("cadastros.editar-situacao-financeira");

    return (
        <Card>
            <CardContent>

                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                    <Stack gap={1}>
                        <Typography variant="body1">
                            {`${data.nome_pessoa}`}
                        </Typography>

                        <Chip
                            size="small"
                            label={getStatusChipProps(data.situacao_financeira).label}
                            sx={getStatusChipProps(data.situacao_financeira).sx}
                            color="default"
                        />
                    </Stack>

                    <Chip icon={<PersonIcon fontSize="small" />} label={`${data.tipo_publico}${data.codigo_publico}`} />
                </Stack>


                <Divider sx={{ my: 1 }} />



                <Stack spacing={2}>
                    <Stack spacing={1}>
                        <Typography variant="subtitle2">
                            <b>{data.documento_pessoa?.length === 11 ? 'CPF:' : 'CNPJ:'}</b> {formatarCPFCNPJ(data.documento_pessoa)}
                        </Typography>
                        <Typography variant="subtitle2">
                            <b>Email:</b> {data.email ? data.email : 'N/A'}
                        </Typography>
                        <Typography variant="subtitle2">
                            <b>Telefone:</b> {data.telefone}
                        </Typography>
                    </Stack>
                </Stack>

                <Stack mt={2} direction="row" alignItems="center" justifyContent="flex-end">
                    {podeEditarSituacaoFinanceira &&
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            startIcon={<EditIcon fontSize="small" />}
                            onClick={() => {
                                setOpenSituacaoFinanceira(true)
                            }}
                        >
                            Editar
                        </Button>
                    }
                </Stack>
                {publicoVerificado && (
                        <Button
                            variant="outlined"
                            fullWidth
                            sx={{ mt: 2 }}
                            onClick={() => openModal(`${data.tipo_publico}${data.codigo_publico}`)}
                        >
                            Ver detalhes financeiros
                        </Button>
                    )
                }
            </CardContent>
            {
                openSituacaoFinanceira &&
                <DialogEditarSituacaoFinanceira
                    publicoId={data.id}
                    open={openSituacaoFinanceira}
                    situacaoFinanceiraAtual={data.situacao_financeira}
                    onClose={() => setOpenSituacaoFinanceira(false)}
                />
            }
        </Card>
    )
}

interface PropsCardResumo extends CardProps {
}

function getStatusChipProps(status: string) {
    let background = "#E0E0E0";
    let textColor = "#444";
    if (status === "PENDENCIAS FINANCEIRAS") {
        background = "#FFD600";
        textColor = "#444";
    } else if (status === "BLOQUEADO MANUAL" || status === "BLOQUEADO DEFINITIVO") {
        background = "#D32F2F";
        textColor = "#fff";
    } else if (status === "LIBERADO" || status === "SEMPRE LIBERADO") {
        background = "#2E7D32";
        textColor = "#fff";
    }
    return {
        sx: {
            background,
            color: textColor,
        },
        color: "default",
        label: status,
    };
}